import { Link, useNavigate } from 'react-router-dom';
import { useCart, useRemoveFromCart } from '../hooks/api-hooks';
import { Empty, ErrorState, Loading } from '../components/States';
import { formatPrice } from '../lib/format';

export function CartPage() {
  const paymentsEnabled = import.meta.env.VITE_PAYMENTS_ENABLED !== 'false';
  const cart = useCart();
  const removeItem = useRemoveFromCart();
  const navigate = useNavigate();

  if (cart.isPending) return <Loading />;
  if (cart.error) return <ErrorState error={cart.error} />;

  const items = cart.data?.items ?? [];
  if (items.length === 0) {
    return (
      <>
        <h1>Giỏ hàng</h1>
        <Empty>
          Giỏ hàng trống. <Link to="/">Xem khoá học và skill</Link>.
        </Empty>
      </>
    );
  }

  return (
    <section aria-labelledby="cart-title">
      <h1 id="cart-title">Giỏ hàng</h1>
      <p className="muted">Kiểm tra lại sản phẩm trước khi tạo đơn và chuyển khoản.</p>
      <ul className="list" aria-label="Sản phẩm trong giỏ hàng">
        {items.map((item) => (
          <li key={item.id}>
            <span>
              <Link to={`/san-pham/${item.product.slug}`}>{item.product.title}</Link>
              <span className="muted">
                {' '}· {item.product.type === 'COURSE' ? 'Khoá học' : 'Skill'}
              </span>
            </span>
            <span>{formatPrice(item.lineTotal)}</span>
            <button
              type="button"
              className="link-button"
              onClick={() => removeItem.mutate(item.product.id)}
              disabled={removeItem.isPending}
              aria-label={`Xoá ${item.product.title} khỏi giỏ hàng`}
            >
              {removeItem.isPending && removeItem.variables === item.product.id
                ? 'Đang xoá…'
                : 'Xoá'}
            </button>
          </li>
        ))}
      </ul>
      {removeItem.error && <ErrorState error={removeItem.error} />}

      {/* Display only. The amount actually charged comes from POST /checkout. */}
      <p className="price" aria-live="polite">
        Tạm tính: {formatPrice(cart.data?.subtotal ?? 0)}
      </p>
      <p className="muted">
        {paymentsEnabled
          ? 'Mã giảm giá sẽ được nhập ở bước thanh toán.'
          : 'Website đang mở để xem thử. Chức năng đặt hàng và thanh toán sẽ được bật sau.'}
      </p>
      <button
        type="button"
        onClick={() => navigate('/thanh-toan')}
        disabled={removeItem.isPending || !paymentsEnabled}
      >
        {paymentsEnabled ? 'Tiến hành thanh toán' : 'Thanh toán chưa mở'}
      </button>
    </section>
  );
}
